<template>
  <div></div>
</template>
<script>
import Cookies from 'js-cookie'

export default {
  name: 'wspSidLogin',
  data() {
    return {}
  },
  created() {
    const url = window.location.href
    if (url.includes('url=')) {
      const myUrl = new URL(url)
      const params = new URLSearchParams(myUrl.hash.split('?')[1])
      const urlParam = params.get('url')
      Cookies.set('nextUrl', urlParam)
      localStorage.setItem('nextUrl', urlParam)
      const channelUrl = 'https://sid.ruijie.com.cn/channel/login?service=https://wsp.ruijie.com.cn'
      window.location = channelUrl
    }
  },
  mounted() {}
}
</script>

<style>
#app iframe {
  border: 0 !important;
  object-fit: contain;
}
#app {
  margin: auto;
  justify-content: center;
  display: flex;
  align-items: center;
}
</style>
